<div class="search-panel-container">
  <mat-toolbar>
    <mat-form-field  class="mat-shadow-1 search-form-field form-slim" [formGroup]="form">
      <button matIconButton matPrefix class="search-button" id="searchButton" type="button" (mousedown)="searchAddress()">
        <mat-icon>search</mat-icon>
      </button>
      <input
        id="searchText"
        #addressInput
        matInput
        formControlName="address"
        autocomplete="off"
        placeholder="Search..."
        [matAutocomplete]="auto"
        class="search-input"
        (click)="selectInputText()" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displaySearch" [class]="'search-history-container'">
        @if ((shouldShowMatAutocomplete$ | async) && (filteredSearches$ | async); as searches) {
          @for (search of searches; track search.formattedAddress || search.location) {
            <mat-option [value]="search" class="search-history-option mat-text-secondary" >
                <mat-icon>history</mat-icon>
                    <span class="mat-font-label-md mat-text-secondary search-text">{{ search.formattedAddress ? search.formattedAddress : search.location }}</span>
                    <button
                            matIconButton
                            (click)="deleteSearch(search, $event)"
                            matTooltip="Remove Search from List"
                            type="button">
                        <mat-icon>close</mat-icon>
                    </button>


            </mat-option>
         }
        }
      </mat-autocomplete>

        @if (addressEl.nativeElement.value.length > 0) {
            <button matSuffix type="button" matIconButton class="close-button" (click)="clearSearchText()">
                <mat-icon>close</mat-icon>
            </button>
        }

    </mat-form-field>
  </mat-toolbar>
</div>
